export const STRINGS = {
    GET_A_QUOTE: "Get a Quote >",
};

export const SESSION_STORAGE = {
    customerData: "customer_data",
};
